import { useMutate } from '@lialo/common/lib/hooks/useMutate';
import { usePaymentServices } from '../../../common/services';
import { CodeType, DiscountCodeInfo, ValidateDiscountCouponRequest } from '../../../common/models/code-info';
import { ErrorType, PaymentError } from '../../../common/error';

export function useValidateDiscountCoupon(onSuccess: (discountCodeInfo: DiscountCodeInfo) => void) {
  const { paymentApi } = usePaymentServices();

  return useMutate<ValidateDiscountCouponRequest, DiscountCodeInfo, PaymentError>(
    async (request: ValidateDiscountCouponRequest) => {
      if (request.code.length === 0) {
        throw new PaymentError(ErrorType.CODE_NOT_FOUND);
      }
      const { type } = await paymentApi.detectCodeType({ code: request.code });
      if (type !== CodeType.DISCOUNT) {
        throw new PaymentError(ErrorType.UNEXPECTED_CODE_TYPE);
      }
      return paymentApi.validateDiscountCode(request);
    },
    {
      onSuccess,
    }
  );
}
